<template>
  <div class="p_cc-ssc">
    <v-p-top @showResult="onShowResult"
             :phase="phase"
             :next_phase="next_phase"
             :open_time="open_time"
             :records="records"
             :name="head.title"
             @end="handle_end"
             :remain_time="remain_time"
             :block_time="block_time"
             @change="changeFp"
    >
      <ul slot="recodeNumber" class="num_record lh_num_record">
        <li v-for="(num, index) in records" :key="'re' + index" class="item lh_item">
          <span class="number" :class="filterNumberColor(index,num)">{{ num }}</span>
        </li>
      </ul>
    </v-p-top>

    <template v-if="!$route.query.notice">
      <v-tab class="page-tabs" v-if="tabs.length" @onChangeTab="onTabChanged" :current="tabs[curTab].value" :tabs="tabs"
             :border="true"/>

      <div class="cc_ssc-main page-wrapper" :style="contentStyleObj">

        <!--<c-input class="c-input" v-model="chip" @again="handle_again" @certain="certain_handle"
                 @reset="reset_selected"></c-input>-->
                 

        <component :chip="chip.toString()" ref="c_model_input" :is="componentName" :data="tabItemData"
                   class="component-page"></component>

        <c-input class="c-input" v-model="chip" @again="handle_again" @certain="certain_handle"
                 @reset="reset_selected"></c-input>
        <table id="longstable" width="872" style="margin-bottom:5px;table-layout:fixed;word-wrap:break-word; background-color:#299265; border: 1px solid #09EC8B;">
		    <tbody>
          <tr class="Conter_list lh_num_record" v-for="count in 7" :key="count">
            <td class="AllAns" v-for="index in 29" :key="index"><span class="number" :class="'number-' + award[count-1+(index-1)*7]">{{award[count-1+(index-1)*7]}}</span></td>
          </tr>
        </tbody>
        </table>
        <v-statistic @showRule="onShowRule" class="page-side"></v-statistic>
      </div>
    </template>
    <template>
      <div class="listen">
        <audio controls="controls" hidden id="audio1">
          <source src="../../../assets/1.mp3" type="audio/mpeg"/>
        </audio>
        <audio controls="controls" hidden id="audio2">
          <source src="../../../assets/2.mp3" type="audio/mpeg"/>
        </audio>
        <audio controls="controls" hidden id="audio3">
          <source src="../../../assets/3.mp3" type="audio/mpeg"/>
        </audio>
      </div>
    </template>
    <order ref="order" @submit="order_sub" :orders="orders"/>
  </div>
</template>

<script>
  import methods from '../methods';
  import Order from '../../../components/dialog/order';
  import VStatistic from '../../../components/c_statistics';
  import FANTAN from '../../../components/pageComponents/fantan/fantan-1'
  import VPTop from '../../../components/c_top';
  import VTab from '../../../components/c_tab';
  import CInput from '../../../components/c_a-input';
  import eventMixin from '../../../utils/eventMixin';
  import {mapState, mapActions} from 'vuex';
  import {computedDataFt} from '../../../utils/computed';
  import { getDrawList } from '@/service/user'
  const each = (cb, el) => {
    (el.name === 'g_input_selected_item' || el.name === 'g_input_selected_item_type_2') && cb(el);
    if (el.$children.length > 0) el.$children.forEach(child => each(cb, child));
  };

  export default {
    name: "fantan",
    mixins: [eventMixin, methods],
    components: {
      Order,
      FANTAN,
      VPTop,
      VTab,
      CInput,
      VStatistic
    },
    data() {
      return {
        origin_list: null,
        // 最后选择的订单号
        orders: [],
        order_subing: false,
        // 连码选择
        curInnerTab: 0,
        // 筹码
        chip: '',

        // 时时彩
        time: 0,
        contentStyleObj: {
          height: ''
        },
        award:[],
      }
    },
    computed: {
      ...mapState({
        notice: state => state.notice,
        curTab: state => state.home_cc_ssc.curTab,
        headTabs: state => state.home.headTabs,
        tabs: state => state.home_cc_ssc.tabs,
        odds: state => state.home_cc_ssc.odds,
        lottery: state => state.home_cc_ssc.lottery,
        order_history: state => state.home_cc_ssc.order_history,
        longQueue: state => state.home.longQueue,
        statistics: state => state.home.statistics
      }),
      current() {
        return this.tabs[this.curTab] || null;
      },
      // 封盘倒计时
      remain_time() {
        return this.lottery.next_info.remain_time;
      },
      // 下一期开盘倒计时
      block_time() {
        return this.lottery.next_info.block_time;
      },
      next_phase() {
        return this.lottery.next_info.period;
      },
      open_time() {
        return this.lottery.next_info.open_time || '';
      },
      // 期数
      phase() {
        return this.lottery.latest_result.period;
      },
      // 开奖号码
      records() {
        return this.lottery.latest_result.number ? this.lottery.latest_result.number.split(',') : [];
      },
      head() {
        return this.headTabs.find(item => item.lottery_type == this.$route.query.lottery_type) || {};
      },
      componentName() {
        return 'F-A-N-T-A-N';
      },
      tabItemData() {
        const odds = this.odds.map(item => {
          if (!item._status) item._status = item.status;
          // 封盘中
          if (!this.time) {
            item.status = 3;
          } else if (item.status === 3) {
            item.status = item._status;
          }
          return item;
        });
        return computedDataFt(odds, this.current, this.curInnerTab);
      }
    },
    methods: {
      ...mapActions({
        createOrder: 'home_cc_ssc/createOrder',
        getNewLotteryRes: 'home_cc_ssc/getNewLotteryRes',
        updateUserInfo: 'root/updateUserInfo',
        getLotteryLatest: 'home/getLotteryLatest',
        getLongQueue: 'home/getLongQueue',
        getStatistics: 'home/getStatistics'
      }),
      getHeight() {
        /*var sUserAgent = navigator.userAgent.toLowerCase();
        if (
          /ipad|iphone|midp|rv:1.2.3.4|ucweb|android|windows ce|windows mobile/.test(
            sUserAgent
          )
        ) {

        }else{
          this.contentStyleObj.height = window.innerHeight - 220 + 'px';
        }*/
      },
      filterNumberColor(index,checkNumber) {
        if(index==0){
          return 'ball_yellow';
        }else{
          return 'number-'+checkNumber;
        }
      },
      updateDrawList() {
        clearInterval(this.timer);
        this.timer = setInterval(() => {
            this.getResultList();
        }, 5000);
      },
      async getResultList() {
        this.award = await getDrawList();
      }
    },
    created() {
      var lett = this;
      document.onkeydown = function (e) {
        var key = window.event.keyCode;
        if (key == 13) {
          if (lett.$refs.order.showOrderDialog === true) {
            lett.$refs.order.handle_submit();
          } else {
            lett.certain_handle();
          }
        }
      }
      window.addEventListener('resize', this.getHeight);
      this.getHeight();
    },
    mounted() {
      this.getResultList();
      this.updateDrawList();
    },
    beforeDestroy() {
      clearInterval(this.timer);
    }
  }
</script>

<style scoped lang="stylus">
  .p_cc-ssc {
    .cc_ssc-main {
      background-color #ffffff
    }
  }

  .num_record {
    text-align left
    height 25px

    > .item2 {
      width 25px
      height 25px
    }

    > .item2 + .item2 {
      margin-left 15px
    }

    > .item {
      height 25px
    }
  }
  .lh_num_record {
  display: inline-flex;
  vertical-align: top;

  .lh_item {
    display: flex;
    align-items: center;
    width: 50px;
    margin-right: 15px;
    margin-left: 0px !important;
  }

  .number {
    width: 25px;
    height: 25px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-size: contain;
    font-size: 13px;
    font-weight: bold;
  }
  .ball_yellow{
    color:#363636;
    background: url('../../../assets/ball_yellow.png') no-repeat center center;
  }
  .number-1 {
    color:#363636;
    background: url('../../../assets/1.fw.png') no-repeat center center;
    background-size: 95%;
  }

  .number-2 {
    color:#363636;
    background: url('../../../assets/2.fw.png') no-repeat center center;
    background-size: 95%;
  }

  .number-3 {
    color:#363636;
    background: url('../../../assets/3.fw.png') no-repeat center center;
    background-size: 95%;
  }

  .number-4 {
    color:#363636;
    background: url('../../../assets/4.fw.png') no-repeat center center;
    background-size: 95%;
  }
}
.AllAns {
    width: 28 px;
    height: 28px;
    background-size: 26px;
    background-position: center;
    background-repeat: no-repeat;
    color: rgb(68, 30, 11);
    text-shadow: -1px -1px 1px #ffffff, 1px 1px 1px #ffffff, -1px 1px 1px #ffffff, 1px -1px 1px #ffffff;
    text-align: center;
    border: 1px solid #09EC8B;
}
</style>



// WEBPACK FOOTER //
// src/pages/home/fantan/index.vue